import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {injectIntl, IntlShape} from 'react-intl'

interface IProps{
    open: boolean,
    handleClose: () => void,
    onConfirm: () =>  void,
    title: string,
    content: string,
    intl: IntlShape
}

function AlertDialog(props: IProps) {
    const {intl} = props
    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose} style={{color:'#0C7CFF'}} >
                        {intl.formatMessage({id: 'cancel'})}
                    </Button>
                    <Button onClick={props.onConfirm} style={{color:'#0C7CFF'}}  autoFocus>
                        {intl.formatMessage({id: 'confirm'})}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default injectIntl(AlertDialog)